import React from "react";
import { NavLink, Outlet, Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LayoutDashboard, Box, FileText, Inbox, Settings, LogOut, Globe, Users, Mail } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_dfd40c82-155c-446f-b6a2-3614c96b8638/artifacts/l43p30e7_Frame%20%283%29%20%282%29.png";

const links = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/products", icon: Box, label: "Products" },
  { to: "/admin/blog", icon: FileText, label: "Blog" },
  { to: "/admin/contacts", icon: Inbox, label: "Contacts" },
  { to: "/admin/newsletter", icon: Mail, label: "Newsletter" },
  { to: "/admin/users", icon: Users, label: "Admin Users" },
  { to: "/admin/settings", icon: Settings, label: "Site Settings" },
];

const AdminLayout = () => {
  const { user, loading, logout } = useAuth();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-zinc-100 flex">
      <aside className="w-64 bg-white border-r border-zinc-200 flex flex-col">
        <Link to="/admin" className="flex items-center gap-3 px-6 h-16 border-b border-zinc-200">
          <img src={LOGO} alt="logo" className="h-8 w-auto" />
          <span className="font-display font-black tracking-tight">Reptile<span className="text-orange-500">CMS</span></span>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-semibold ${
                  isActive ? "bg-orange-500 text-white" : "text-zinc-700 hover:bg-zinc-100"
                }`
              }
            >
              <l.icon size={16} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-zinc-200 space-y-2">
          <Link to="/" data-testid="admin-view-site" className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-semibold text-zinc-700 hover:bg-zinc-100">
            <Globe size={16} /> View site
          </Link>
          <button
            onClick={logout}
            data-testid="admin-logout"
            className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm font-semibold text-zinc-700 hover:bg-red-50 hover:text-red-600"
          >
            <LogOut size={16} /> Sign out
          </button>
          <div className="text-xs text-zinc-500 px-3 pt-2">{user.email}</div>
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <div className="px-8 py-8 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
